// extracted by mini-css-extract-plugin
module.exports = {"darkTheme":"PerformanceInput_darkTheme__3WwdB"};